/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerAccountMarginReportQuery($customerAccountId: ID!, $endDate: DateTime!, $startDate: DateTime!) {
  CustomerAccountMarginReport(customerAccountId: $customerAccountId, endDate: $endDate, startDate: $startDate) {
    id,
    status,
    message,
    _report
  }
}
`
